var map = {
	"./action_image.png": 410,
	"./dimond.png": 411,
	"./logo_01.png": 61,
	"./logo_02.png": 177,
	"./logo_03.png": 178,
	"./logo_04.png": 62,
	"./logo_05.png": 63,
	"./p_feature1.png": 412,
	"./prototype_banner_img.png": 413,
	"./prototype_banner_img2.png": 414,
	"./psd.png": 415,
	"./saas.png": 416,
	"./tab.png": 417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;